import { useQuery } from "react-query";
import API from "../shared-utils/api";
import { useCustomer } from "../contexts/CustomerProvider";
import { API_ENDPOINTS } from "../shared-constants";
export const getWallet = async (userId, pubId) => {
    if (!userId)
        return null;
    const { data } = await API.get(API_ENDPOINTS.WALLET.FETCH_DETAILS(userId, pubId));
    return data;
};
export const useWallet = (pubId) => {
    var _a;
    const { customerData } = useCustomer();
    const userId = (_a = customerData === null || customerData === void 0 ? void 0 : customerData.id) !== null && _a !== void 0 ? _a : null;
    return useQuery(["wallet", userId, pubId], () => getWallet(userId, pubId), {
        enabled: !!userId,
    });
};
